import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from '@config/theme';
import { DialogProvider } from '@contexts/DialogContext';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Failed to find the root element');
}
const root = ReactDOM.createRoot(rootElement);
root.render(_jsx(React.StrictMode, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(SnackbarProvider, { children: _jsx(DialogProvider, { children: _jsx(AuthProvider, { children: _jsx(App, {}) }) }) })] }) }));
